{
  "name": "Solaris",
  "version": "1.1",
  "repository": "https://github.com/chxry/sun",
  "license": "MIT",
  "scripts": {
    "dev": "parcel src/index.html",
    "prod": "parcel build src/index.html --public-url ./",
    "prettier": "prettier --write src",
    "deploy": "firebase deploy"
  },
  "dependencies": {
    "@heroicons/react": "^1.0.5",
    "firebase": "^9.6.5",
    "i18next": "^21.6.10",
    "react": "^17.0.2",
    "react-circle-flags": "^0.0.15",
    "react-dom": "^17.0.2",
    "react-i18next": "^11.15.3",
    "react-router-dom": "^6.2.1"
  },
  "devDependencies": {
    "@types/react": "^17.0.38",
    "@types/react-dom": "^17.0.11",
    "@types/react-router-dom": "^5.3.3",
    "autoprefixer": "^10.4.2",
    "parcel": "^2.2.1",
    "postcss": "^8.4.5",
    "prettier": "^2.5.1",
    "tailwindcss": "^3.0.18"
  }
}
